import { Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { CloseButton } from 'src/components/ui/close-button';

const HIDDEN_KEY = 'alitu-preview-banner-hidden';

function isHidden() {
  try {
    return sessionStorage.getItem(HIDDEN_KEY) === '1';
  } catch {
    return false;
  }
}

function isScenarioRunner() {
  return document.cookie.split(';').some(part => part.trim() === 'alitu-scenario-runner=1');
}

function PreviewBanner() {
  const pr = process.env.PREVIEW_PR;
  const sha = process.env.PREVIEW_SHA;
  const needsRebase = process.env.PREVIEW_NEEDS_REBASE === '1';
  const [hidden, setHidden] = useState(isHidden);

  if (!pr || !sha || hidden || isScenarioRunner()) {
    return null;
  }

  const label = needsRebase
    ? `PR #${pr} · ${sha.slice(0, 7)} · needs rebase`
    : `PR #${pr} · ${sha.slice(0, 7)}`;

  return (
    <Flex
      align="center"
      bg="yellow.300"
      color="black"
      fontWeight="bold"
      h="36px"
      justify="center"
      lineHeight="36px"
      position="relative"
      px="10"
      width="100%"
    >
      {label}
      <CloseButton
        aria-label="Hide preview banner"
        position="absolute"
        right="1"
        size="xs"
        onClick={() => {
          sessionStorage.setItem(HIDDEN_KEY, '1');
          setHidden(true);
        }}
      />
    </Flex>
  );
}

export default PreviewBanner;
